import ModalService, { modalNames } from 'Services/ModalService'

class ConfirmationDialog {
  create (title, description, question, buttons) {
    return new Promise((resolve, reject) => {
      ModalService.open(modalNames.CONFIRMATION_DIALOG, {
        title,
        description,
        question,
        buttons,
        resolve,
        reject,
      })
    })
  }
}

export default new ConfirmationDialog()
